import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type SdmModuleSpecsFragment } from '../../../../../api/fragments';
import BankIntegrationActions from './BankIntegrationActions';
import BankIntegrationsEmpty from './BankIntegrationsEmpty';

export type BankIntegrationsProps = {
    module: SdmModuleSpecsFragment;
    openBankIntegrationDrawer: (bankIntegrationId?: string) => void;
};

const BankIntegrations = ({ module, openBankIntegrationDrawer }: BankIntegrationsProps) => {
    const { t } = useTranslation(['sdmModuleDetails']);

    const renderActions = useCallback(
        (record: SdmModuleSpecsFragment['banks'][number]) => (
            <BankIntegrationActions
                bank={record}
                module={module}
                openBankIntegrationDrawer={openBankIntegrationDrawer}
            />
        ),
        [module, openBankIntegrationDrawer]
    );

    if (module.banks.length === 0) {
        return <BankIntegrationsEmpty openBankIntegrationDrawer={openBankIntegrationDrawer} />;
    }

    return (
        <Table dataSource={module.banks} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('sdmModuleDetails:bankIntegrationTable.columns.displayName')}
            />
            <Table.Column
                key="identifier"
                dataIndex="identifier"
                title={t('sdmModuleDetails:bankIntegrationTable.columns.identifier')}
            />
            <Table.Column
                key="integration.provider"
                dataIndex={['integration', 'provider']}
                title={t('sdmModuleDetails:bankIntegrationTable.columns.integrationProvider')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('sdmModuleDetails:bankIntegrationTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default BankIntegrations;
